/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_LinkInputs */

const en_start_page_link = /** @type {(inputs: Start_Page_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`complete-athlete.co/t/kate-morgan`)
};

const pl_start_page_link = /** @type {(inputs: Start_Page_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`complete-athlete.co/t/kasia-wrona`)
};

/**
* | output |
* | --- |
* | "complete-athlete.co/t/kate-morgan" |
*
* @param {Start_Page_LinkInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_link = /** @type {((inputs?: Start_Page_LinkInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_LinkInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_link(inputs)
	return en_start_page_link(inputs)
});